<template>
	<div class="history-page">
		<navBar>
			<span class="title">{{ title }}的学习报告</span>
		</navBar>
		<van-tabs
			@click="changeCourse"
			v-if="listData.length > 0"
			style="border-top: 1px solid #dcdcdc"
			color="#2db79a"
			title-active-color="#2db79a"
			:line-width="20"
		>
			<van-tab :title="item.bookname" :key="index + 'tabl'" v-for="(item, index) in listData" />
		</van-tabs>
		<!-- 	<div class="ceBox" v-if="!show">
			<div class="item" @click="show = true">
				{{ courseData.children[ceNav].name }}
				<van-icon name="arrow" />
			</div>
		</div>
		<div class="childBox" v-if="show">
			<div
				class="item"
				:key="index + item.id"
				v-for="(item, index) in courseData.children"
				@click="
					ceNav = index;
					show = false;
				"
			>
				{{ item.name }}
			</div>
		</div> -->
		<div class="page-content" style="">
			<!-- 	<courseList
				class="courseList"
				:courseData="listData[activeNav].children"
				v-if="listData[activeNav].children.length"
			></courseList> -->
			<ul data-v-8842613e="" data-v-3b0c8fe6="" class="course-list courseList">
				<li data-v-8842613e="" v-for="(item,i) in listData[activeNav].children" :key="'kety'+i">
					<div data-v-8842613e="" class="course-img">
						<div data-v-8842613e="" class="img van-image">
							<img
								:src="item.chaptericon"
								class="van-image__img"
								style="object-fit: cover"
							/>
						</div>
					</div>
					<div data-v-8842613e="" class="course-infs">
						<div data-v-8842613e="" class="course-name">{{item.chaptername}}</div>
						<div data-v-8842613e="" class="course-author-unit font28">
							<span data-v-8842613e="">{{item.createtime}}</span>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
// import courseList from '@/components/courseList.vue';
export default {
	name: 'moreHistory',
	components: {
		// courseList
	},
	data() {
		return {
			courseData: [],
			allData: [],
			activeNav: 0,
			ceNav: 0,
			show: false,
			title: '',
			listData: []
		};
	},
	computed: {
		...mapGetters({
			userInfs: 'userCenter/getUserInfs'
		})
	},
	created() {
		this.getLastLearn();
		this.title = this.userInfs.username;
	},
	mounted() {},
	methods: {
		getLastLearn() {
			let that = this;
			that.$api
				.getstudyreport({
					type: 1
				})
				.then((res) => {
					let resData = res.data || [];
					this.listData = resData;
				});
		},
		changeCourse(idx) {
			if (idx != 100) {
				this.courseData = this.allData[idx];
			}
			console.log(idx);
			this.activeNav = idx;
			this.ceNav = 0;
		}
	}
};
</script>

<style lang="scss" scoped>
.history-page {
	padding-top: 1.08rem;
}
.page-content {
	padding: 0.28rem;
	height: calc(100vh - 2.8rem);
	min-height: calc(100vh - 2.8rem);
}
.course-nav {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 0.55rem;
	li {
		position: relative;
		margin-right: 0.4rem;
		font-size: 0.28rem;
		font-weight: 400;
		color: #909090;
		transition: all 0.3s ease-in;
		&::after {
			position: absolute;
			left: 50%;
			bottom: -0.15rem;
			height: 0.04rem;
			width: 0.24rem;
			content: '';
			background: #28b396;
			border-radius: 0 02rem;
			opacity: 0;
			transition: all 0.3s ease-in;
			transform: translateX(-50%);
		}
		&::before {
			position: absolute;
			left: 0;
			right: 0;
			z-index: 2;
			bottom: -0.05rem;
			height: 0.1rem;
			content: '';
			background: #fff;
		}
		&.active {
			position: relative;
			font-weight: 500;
			font-size: 0.28rem;
			color: #28b396;
			&::after {
				opacity: 1;
			}
		}
	}
}
.ceBox,
.childBox {
	border-top: 5px solid #dcdcdc;
	border-bottom: 5px solid #dcdcdc;
	font-size: 0.24rem;
	.item {
		border-bottom: 1px solid #dcdcdc;
		padding: 10px 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
.courseList {
	li {
		width: 100%;
		margin-bottom: 0.3rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #fff;
		border-radius: 0.1rem;
		padding: 0.1rem 0.2rem;
		.course-img {
			width: 0.9rem;
			margin-right: 0.26rem;
			overflow: hidden;
			.img {
				width: 100%;
				height: 100%;
			}
		}
		.course-infs {
			flex: 1;
			display: flex;
			justify-content: center;
			flex-direction: column;
			.course-name {
				width: 100%;
				font-size: 0.28rem;
				font-weight: 500;
				color: #333;
				margin-bottom: 0.15rem;
			}
			.course-author-unit {
				display: flex;
				flex-wrap: wrap;
				font-weight: 400;
				color: #909090;
			}
		}
	}
}
</style>
